import React, { ReactNode, useState } from 'react';
import { JsonPropsType } from '../../component-loader';
import { AsyncTable, AsyncTableProps } from './AsyncTable';
import { formatDateStringToDisplay, formatToLocaleNumberString } from '../../utils/format';
import { FundReturnOfCapital } from '../../types/funds';

type FundReturnsTableProps = AsyncTableProps<FundReturnOfCapital>;

export function FundReturnsTable(props: JsonPropsType<FundReturnsTableProps>) {
  const [fundReturns, setFundReturns] = useState<FundReturnOfCapital[]>([]);

  if (!props.jsonObject) return <div />;

  const { url, columns } = props.jsonObject;
  const onSuccess = (data: FundReturnOfCapital[]) => setFundReturns(data);

  const rows: ReactNode[] = fundReturns.map((fundReturn) => (
    <tr key={fundReturn.id}>
      <td>{formatDateStringToDisplay(fundReturn.date)}</td>
      <td>
        {formatToLocaleNumberString({
          value: fundReturn.total,
          currencyFormat: 'clp',
          round: true,
        })}
      </td>
      <td>
        {formatToLocaleNumberString({
          value: fundReturn.amount,
          currencyFormat: 'clp',
          round: true,
        })}
      </td>
      <td>{fundReturn.fund_series}</td>
    </tr>
  ));

  return (
    <AsyncTable<FundReturnOfCapital>
      jsonObject={{
        url,
        onSuccess,
        columns,
        rows,
      }}
    />
  );
}
